import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button,
  TextField,
  Typography,
  GridLegacy as Grid
} from '@mui/material';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import useClasses from '../../../helpers/useClasses';

const styles = theme => ({
  root: {},
  instructionText: {
    marginTop: theme.spacing(1),
    fontSize: '1.1rem'
  },
  instructionText: {
    marginTop: theme.spacing(1),
    fontSize: '1.1rem',
    paddingBottom: '20px'
  }
});

const categories = [
  { value: '', label: '' },
  { value: 'Default Account', label: 'Default Account' },
  { value: 'Suspicious Activity', label: 'Suspicious Activity' },
  { value: 'Slow Pay', label: 'Slow Pay' },
  { value: 'Stacking History', label: 'Stacking History' },
  { value: 'Open Funding', label: 'Open Funding' },
  { value: 'Other', label: 'Other' },
  { value: 'Default/Slow Pay Satisfied', label: 'Default/Slow Pay Satisfied' },
];

const NoteChangeRequestDialog = props => {
  const { className, merchantNote, open, onCancelClick, onSubmitClick } = props;
  const [id, setId] = useState(merchantNote.id);
  const [newCategory, setNewCategory] = useState('');
  const [newNote, setNewNote] = useState('');

  const classes = useClasses(styles);

  useEffect(() => {
    setId(merchantNote.id);
    setNewCategory('');
    setNewNote('');
  }, [merchantNote]);

  return (
    <Dialog
      className={clsx(classes.root, className)}
      open={open}
      onClose={onCancelClick}
      maxWidth={'md'}
      fullWidth
    >
      <DialogTitle>Default Account Change Request</DialogTitle>
      <Divider />
      <DialogContent>
        <form autoComplete="off">
          <Typography variant="body1" className={classes.instructionText}>
            Please fill out this form to request changes to a default entry. If the account has been satisfied, please add an additional note under the Default/Slow Pay Satisfied category.
          </Typography>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Current Category"
                margin="dense"
                value={merchantNote.category || ''}
                variant="outlined"
                disabled
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Current Note"
                margin="dense"
                value={merchantNote.note || ''}
                variant="outlined"
                disabled
                multiline
                minRows={2}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Requested New Category"
                margin="dense"
                name="new_category"
                onChange={(e) => setNewCategory(e.target.value)}
                required
                select
                SelectProps={{ native: true }}
                value={newCategory}
                variant="outlined"
              >
                {categories.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Requested New Note"
                margin="dense"
                name="new_note"
                onChange={(e) => setNewNote(e.target.value)}
                required
                value={newNote}
                variant="outlined"
                multiline
                minRows={2}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button color="secondary" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              onClick={(event) => {
                const form = event.currentTarget.form;
                if (form.reportValidity()) {
                  onSubmitClick(event, {
                    id: id,
                    new_category: newCategory,
                    new_note: newNote
                  });
                }
              }}
            >
              Submit Change Request
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default withErrorHandler(NoteChangeRequestDialog, axios);
